import { StyledInputLabel } from '@/components/features/casino/crash/BetBox/styles';
import { useTranslation } from 'next-i18next';
import { autoBetState } from '@/components/features/casino/crash/state';
import { useAtom, useAtomValue } from 'jotai';
import { SxProps } from '@mui/material';
import React, { useEffect } from 'react';
import { MoonSwitch } from '@/components/ui/MoonSwitch';

export default function AutoBet({ sx }: { sx?: SxProps }) {
  const { t } = useTranslation();
  const [autoBet, setAutoBet] = useAtom(autoBetState);
  const onToggleAutoBet = () => {
    setAutoBet(!autoBet);
  };
  useEffect(() => {
    return () => {
      setAutoBet(false);
    };
  }, []);
  return (
    <StyledInputLabel htmlFor="autoBet" sx={sx}>
      {t('Autobet')}
      <MoonSwitch sx={{ ml: 1 }} checked={autoBet} onChange={onToggleAutoBet} />
    </StyledInputLabel>
  );
}
